// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-e8a7118e]{margin-top:2em}input[data-v-e8a7118e]{margin-top:1em}.route[real-mode=view] .label[data-v-e8a7118e]{color:var(--input-label)}button[data-v-e8a7118e]{margin-left:.5em}a[data-v-e8a7118e]:hover{text-decoration:none}", ""]);
// Exports
module.exports = exports;
